import React from 'react'
import { 
    Box,
    Grid,
    styled,
    Typography,
} from '@mui/material'
import Title from './Title'
// img
import imgDetail from '../assets/featured-basement-egress-window-system-package.webp';
import imgDetail2 from '../assets/featured-basement-escape-egress-window.webp';








const Getgoing = () => {

    const CustomGridItem = styled(Grid) ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor:'#000000'
    })
    
    const CustomTypography = styled(Typography) ({
        fontSize: '1.5rem',
        textAlign: 'start',
        lineHeight: '1.5',
        color: '#ffffff',
        marginTop: '1.5rem',
        padding: 4,
        alignSelf: 'center'
    })

    return (

        
            
        <Grid container id="get-started" spacing={{ xs: 4, sm: 4, md: 0 }}   
        sx={{
            py: 10,
            px: 8,
            backgroundColor:'#000000'
             
        }}
        >


            <CustomGridItem item xs={12} sm={8} md={6} 
            component = 'section'           
            >
                

                <Box component='article'
                sx={{
                    px: 4,
                    width: '80%',
                    margin: '0px auto',
                    '@media (max-width:420px)': {
                        width: '90%'
                        
                      }   
                }}
                >


                    
                    <CustomTypography>
                    <Title
                    text={
                        'The Benefits of Basement Egress Windows'
                        
                    }
                    textAlign={'start'}
                    />
                    <br/>
                        
                        Basement Egress Window Systems <br />
                        bring natural light and energy into<br />
                        your basement, making it a more habitable space.
                    </CustomTypography> 
                </Box>
                

            </CustomGridItem>
            
            <Grid item xs={12} sm={8} md={6}>
                <img src={imgDetail} alt="1" 
                style={{
                    width: '100%',
                }}
                />
            </Grid>

            <Grid item xs={12} sm={8} md={6}
            sx={{
                order: {xs: 4, sm: 4, md: 3}
            }}
            >
                <img src={imgDetail2} alt="escape egress window" 
                style={{ 
                    width: "100%",
                }}
                />
            </Grid>

            <CustomGridItem item xs={12} sm={8} md={6}
            sx={{
                order: {xs: 3, sm: 3, md: 4}
            }}
            >
                <Box component='article'
                sx={{
                    px: 4,
                    width: '80%',
                    margin: '0px auto',
                    '@media (max-width:420px)': {
                        width: '90%'
                        
                      }   
                }}
                >
                    <Title
                    text={
                        'Early in the business we found the best egress window systems and have perfected the process.'
                        
                    }
                    textAlign={'start'}
                    />
                    <CustomTypography>
                        Request a custom egress window installation<br/>
                        quote today!
                    </CustomTypography>
                </Box>
            </CustomGridItem>

            
        </Grid>
    )
}

export default Getgoing;